(function () {
  'use strict';

  function getButtons(wrapper) {
    return Array.prototype.slice.call(
      wrapper.querySelectorAll('.product-description-tabs__button')
    );
  }

  function getPanels(wrapper) {
    return Array.prototype.slice.call(
      wrapper.querySelectorAll('.product-description-tabs__panel')
    );
  }

  function activate(wrapper, button, moveFocus) {
    var buttons = getButtons(wrapper);
    var panels = getPanels(wrapper);
    var targetPanelId = button.getAttribute('data-tab');

    buttons.forEach(function (item) {
      var isActive = item === button;

      item.classList.toggle('active', isActive);
      item.setAttribute('aria-selected', String(isActive));
      item.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach(function (panel) {
      var isActive = panel.id === targetPanelId;

      panel.classList.toggle('active', isActive);
      panel.hidden = !isActive;
    });

    if (moveFocus) {
      button.focus();
    }
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var button = event.target.closest(
      '.product-description-tabs__button'
    );

    if (!button) return;

    var wrapper = button.closest('[data-product-tabs]');

    if (!wrapper) return;

    activate(wrapper, button, false);
  });

  document.addEventListener('keydown', function (event) {
    if (!(event.target instanceof Element)) return;

    var currentButton = event.target.closest(
      '.product-description-tabs__button'
    );

    if (!currentButton) return;

    var wrapper = currentButton.closest('[data-product-tabs]');

    if (!wrapper) return;

    var buttons = getButtons(wrapper);
    var currentIndex = buttons.indexOf(currentButton);
    var nextIndex = currentIndex;

    if (event.key === 'ArrowRight') {
      nextIndex = currentIndex + 1;

      if (nextIndex >= buttons.length) {
        nextIndex = 0;
      }
    } else if (event.key === 'ArrowLeft') {
      nextIndex = currentIndex - 1;

      if (nextIndex < 0) {
        nextIndex = buttons.length - 1;
      }
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = buttons.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    activate(wrapper, buttons[nextIndex], true);
  });
})();